import { handle } from "redux-pack";
import * as actionTypes from "../../constants/actionTypes";
import { handleDataStatus, initialDataStatus } from "./shared/dataStatus";

const status = (state = initialDataStatus, action) => {
  switch (action.type) {
    case actionTypes.LOAD_SIM_ONLY_OFFERS_DATA:
      return handleDataStatus(state, action);
    case actionTypes.INVALIDATE_SIM_ONLY_OFFERS_DATA:
    case actionTypes.INVALIDATE_PORTAL_OFFER_DATA:
      return { ...state, didInvalidate: true };
    default:
      return state;
  }
};

const entities = (state = [], action) => {
  switch (action.type) {
    case actionTypes.LOAD_SIM_ONLY_OFFERS_DATA:
      if (action.payload !== undefined) {
        return handle(state, action, {
          success: prevState => action.payload
        });
      } else {
        return state;
      }
    default:
      return state;
  }
};

export { entities, status };
